<template>
  <div id="app">
    <v-app v-if="!loaded">
    loading...
    </v-app>
    <v-app v-else-if="loaded && !isProfileCompleted">
      <profile/>
    </v-app>
    <v-app v-else>
      <v-navigation-drawer app v-model="drawer">
        <v-list nav dense>
          <v-list-item v-if="user">
            <v-list-item-content>
              <v-list-item-title>{{ user.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.nickname }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item :to="{ name: 'Receipts' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Показания</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Statistics' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Статистика</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Counters' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-counter</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Счетчики</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Profile' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Профиль</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="isAdmin" :to="{ name: 'Users' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Пользователи</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="isAdmin" :to="{ name: 'Houses' }" exact>
            <v-list-item-icon>
              <v-icon>mdi-home-city</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Дома/адреса</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>

      <v-app-bar app>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
      </v-app-bar>


      <!-- Sizes your content based upon application components -->
      <v-main>

        <!-- Provides the application the proper gutter -->
        <v-container fluid>

          <!-- If using vue-router -->
          <router-view></router-view>
        </v-container>
      </v-main>

      <v-footer app>
        <!-- -->

      </v-footer>

    </v-app>

  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import Profile from "@/components/Profile"

export default {
  name: 'App',
  components: {
    Profile,
  },

  data() {
    return {
      pageTitle: this.$router.currentRoute.meta.title,
      drawer: null,
      group: null,
      loaded: false,
    }
  },

  created() {
    this.$root.$on("set-page-title", title => this.pageTitle = title)
    this.$http.get("/user/current").then(resp => {
          this.$store.commit({type: "setUser", user: resp.data})
          this.loaded = true
        }
    )
  },

  computed: {
    user: function () {
      return this.$store.state.user
    },
    isAdmin: function () {
      return this.$store.state.user?.isAdmin
    },
    isProfileCompleted: function () {
      function notEmpty(str) { return str != null && str.trim().length > 0 }
      let u = this.$store.state.user
      if (u == null) return
      return notEmpty(u.houseId) && notEmpty(u.name) && notEmpty(u.flat)
    },

  },

}
</script>

<style>
</style>
